import { Frown } from "lucide-react";

const Empty = ({
  label,
  labelSize,
  Icon,
  description,
  descriptionSize,
  className = "",
  button = "",
}) => {
  return (
    <div className={`empty ${className}`}>
      <div className="icon">{Icon ? Icon : <Frown />}</div>

      {label && (
        <span className={`label`} style={{ fontSize: labelSize + "px" }}>
          {label}
        </span>
      )}
      {description && (
        <p style={{ fontSize: descriptionSize + "px" }}>{description}</p>
      )}
      {button && button}
    </div>
  );
};

export default Empty;
